import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-eg-dialog',
  standalone: true,
  imports: [MatDialogModule,MatButtonModule,FormsModule,CommonModule,MatFormFieldModule,MatInputModule,NgbRatingModule],
  templateUrl: './eg-dialog.component.html',
  styleUrl: './eg-dialog.component.scss'
})
export class EgDialogComponent {
  feedback : string = '';
  rating : any = 0;
  MAX_COMMENTS_LENGTH = 500;
  constructor(private readonly dialogRef: MatDialogRef<EgDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  isSubmitDisabled(): boolean {
    return this.rating === 0 || this.feedback == '';
  }

  submit() {
    if (!this.isSubmitDisabled()) {
      this.dialogRef.close(
        {
          data:
          {
            feedback : this.feedback,
            rating : this.rating
          },

        }
      );
    }
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
